'use client';

import { Typography } from '@boostdev/design-system-components';
import { Button } from '@/components/atoms/Button/Button';

export default function Error({ reset }: { reset: () => void }) {
  return (
    <div className="mx-auto my-4 flex max-w-xl flex-col rounded-lg border border-neutral-200 bg-white p-8 md:p-12 dark:border-neutral-800 dark:bg-black">
      <Typography variant="h2">Oh no!</Typography>
      <Typography variant="body">
        There was an issue with our storefront. This could be a temporary issue, please try your
        action again.
      </Typography>
      <Button onClick={() => reset()}>Try Again</Button>
    </div>
  );
}
